import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { ThirdPartiesCmp_SomeOrganizations_QueryDocument } from '../queries/some-organizations.query';

export const useFindAllDeletedExternalOrganizationsQuery = (enabled = true) => {
  const { genericStatusesCodeMap } = useReferencesContext();

  return useGraphQLQuery(
    ThirdPartiesCmp_SomeOrganizations_QueryDocument,
    {
      statusId: genericStatusesCodeMap.Deleted._id,
      isInternal: false,
    } as const,
    { enabled },
  );
};
